import { render } from "./DragToUpload.vue?vue&type=template&id=5880b4b3"
import script from "./DragToUpload.vue?vue&type=script&lang=ts"
export * from "./DragToUpload.vue?vue&type=script&lang=ts"
script.render = render

export default script